// extracted by mini-css-extract-plugin
export default {"carbon-market":"carbon-market_carbon-market__4fU28","offset":"carbon-market_offset__gj5JI","bleed":"carbon-market_bleed__ct3DA"};